export default "__VITE_ASSET__$uv55Bd5__"